// Move one item from index `from` to index `to` (both 0-based); others shift. Returns a new array.
export function moveItem(list, from, to) {
  if (from === to || from < 0 || to < 0 || from >= list.length || to >= list.length) return list;
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

// Parse a user-typed 1-based position; returns a 0-based index or null when invalid.
export function parsePosition(text, length) {
  if (!/^\s*\d+\s*$/.test(String(text))) return null;
  const n = parseInt(text, 10);
  return n >= 1 && n <= length ? n - 1 : null;
}
